import React, { useState, useEffect } from 'react';
import { Container, Image } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import RoundButton from '../../common/RoundButton';
import moment from 'moment';
import Countdown, { zeroPad, formatTimeDelta } from 'react-countdown';
import CreationUpload from '../upload/CreationUpload';
import ChallengeCard from './ChallengeCard';
import AcceptedDependents from './AcceptedDependents';
import {
  NEXT_CHALLENGE_ROUTE,
  MY_ROOM_ROUTE,
  TREEHOUSE_ROUTE,
  CAPTAIN_ROUTE,
  EXPERT_ROUTE,
} from '../../../constants/routes.constants';
import taletreeLogo from '../../../assets/logo/logo-camp.svg'
import defaultProfilePic from '../../../assets/profile/default-profile-guardian.svg';
import ChallengeModal from '../../common/ChallengeModal';
import { ChallengeStatus } from '../../../constants/status.codes.constants';
import { nextChallengeViewModel } from './next.challenge.viewmodel';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { TiArrowRightThick } from '@react-icons/all-files/ti/TiArrowRightThick';
import { BsCheck } from '@react-icons/all-files/bs/BsCheck';
import { BsFillPatchCheckFill } from 'react-icons/bs';
import { FaThLarge } from '@react-icons/all-files/fa/FaThLarge';
import { FaBars } from '@react-icons/all-files/fa/FaBars';
import GetVerifiedNowModal from './getVerifiedNowModal';

import './scss/next.challenge.scss';
import EventEmitter from '../../../utils/events';
import { treehouseViewModel } from '../../common/treehouse.view.model';
import SpecialCamp from '../camp_schedule/SpecialCamp';
import UpgradeModal from './UpgradeModal';
import goldTick from '../../../assets/icon/gold_tick.svg';
import silverTick from '../../../assets/icon/silver_tick.svg';
import greenTick from '../../../assets/icon/green_tick.svg';
import verfiedIcon from '../../../assets/icon/Verified-badge.svg';
import { ACCEPTED_CHALLENGE_ONE_DAY_TO_GO, ACCEPTED_CHALLENGE_PROMPT, NEW_CHALLENGE_PROMPT } from '../../../constants/companionPrompt.constants';
import { schoolViewModel } from '../school/school.view.model';
import { agoraViewModel } from '../../common/agora.view.model';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';

function SingleChallengeDetails({
  challengeState,
  onUploadComplete,
  filter,
  tag,
  from,
  tabFlag,
  setChallengeState,
  setTabFlag,
  acceptedTitle,
  acceptedCount,
  handleToggleAcceptedDependents,
  toggleButton,
  toggleAccepted,
  completedTitle,
  toggleCompletedView,
  handleToggleView,
  hasSubmission,
  noSubmissionView,
  completedView,
  setSubscribedTreehouse,
  subscribedTreehouses,
  setLoading,
  loading,
  acceptPrompt,
  setAcceptPrompt,
  setShowTimeToUpgradePopup,
  getChallengeDetail
}) {
  const history = useHistory();
  const myParam = new URLSearchParams(location.search).get('encrypt');
  const decryptedData = JSON.parse(atob(myParam));
  let cid = decryptedData.id;
  const { dependent, guardian, fetchAPI, partner, school } = useAuth();
  const challenge = challengeState.repos;
  const [challengeStatus, setChallengeStatus] = useState('');
  const [leftTime, setLeftTime] = useState(0); // 7 days
  const [textOfLeftDays, setTextOfLeftDays] = useState('');
  const [accepted, setAccepted] = useState('');
  const [showModal, setShowModal] = useState(false);
  // for Modal
  const [showUpload, setShowUpload] = useState(false);
  const [showGetVerifiedModal, setShowGetVerifiedModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  // Close Modal layer
  const handleCloseUpload = () => {
    setShowUpload(false);
    EventEmitter.dispatch('accept_challenge', {})
    // setPromptType(NEW_CREATION_UPLOAD_PROMPT)
    // EventEmitter.dispatch('show_prompt', {
    //   showPrompt: 'block'
    // })
  };
  const [goToMyRoomCount, setGoToMyRoomCount] = useState(
    localStorage.getItem('gotomyroom')
  );
  // Open Modal layer
  const handleShowUpload = () => setShowUpload(true);

  const [showUploadingGuide, setShowUploadingGuide] = useState(false);
  const [showDisjoinConfirm, setShowDisjoinConfirm] = useState(false);
  const [showExceedMaxChallenge, setShowExceedMaxChallenge] = useState(false);
  const [showGoToMyroom, setShowGoToMyroom] = useState(false);
  const [acceptResponse, setAcceptResponse] = useState();
  const handleCloseUploadingGuide = () => setShowUploadingGuide(false);
  const handleShowUploadingGuide = () => setShowUploadingGuide(true);
  const [promptType, setPromptType] = useState('');

  useEffect(() => {
    if (!dependent) setLoading(false);
    if (partner) {
      if (challenge?.id) {
        if (challenge?.created_by?.user_type !== "" && challenge?.treehouse_user?.agora_group_id && challenge?.agora_group_id !== challenge?.treehouse_user?.agora_group_id) {
          let challengeData = {
            title: challenge?.title,
            description: challenge?.description,
            deadline: challenge?.deadline,
            agora_chat_box: challenge?.agora_chat_box,
            agora_group_id: challenge?.treehouse_user?.agora_group_id
          }
          schoolViewModel.editChallenge(challenge?.id, challengeData).then(async (res) => {
            if (res) {
              let response = await agoraViewModel.getAppToken()
              let params = {
                appToken: response?.data.app_token,
                id: challenge?.agora_group_id
              }
              try {
                if (challenge?.agora_group_id) agoraViewModel.deleteGroup(params)
              } catch (error) {
                console.log(error)
              }
              // window.location.reload();
              getChallengeDetail()
            }
          })
        }
      }
    }
    if (school) {
      if (challenge?.id) {
        if (challenge?.created_by?.user_type !== "" && challenge?.group?.agora_group_id && challenge?.agora_group_id !== challenge?.group?.agora_group_id) {
          let challengeData = {
            title: challenge?.title,
            description: challenge?.description,
            deadline: challenge?.deadline,
            agora_chat_box: challenge?.agora_chat_box,
            agora_group_id: challenge?.group?.agora_group_id
          }
          schoolViewModel.editChallenge(challenge?.id, challengeData).then(async (res) => {
            if (res) {
              let response = await agoraViewModel.getAppToken()
              let params = {
                appToken: response?.data.app_token,
                id: challenge?.agora_group_id
              }
              try {
                if (challenge?.agora_group_id) agoraViewModel.deleteGroup(params)
              } catch (error) {
                console.log(error)
              }
              // window.location.reload();
              getChallengeDetail()
            }
          })
        }
      }
    }
  }, [challenge])

  const showSelected = (id) => {
    if (subscribedTreehouses.indexOf(id) != -1) {
      return true;
    }
    else {
      return false;
    }
  }

  useEffect(() => {
    if (challenge) {
      if (challenge.time_left) setLeftTime(challenge.time_left);
      setChallengeStatus(ChallengeStatus[challenge.challenge_status]);
      setAccepted(challenge.challenge_status !== 'SELECTED' ? '' : 'accepted');
    }
  }, [challengeState]);

  useEffect(() => {
    if (goToMyRoomCount === null) {
      localStorage.setItem('gotomyroom', 2);
      setGoToMyRoomCount(2);
    }
    formatTimeDelta({
      days: '0',
      hours: '00',
      minutes: '00',
      seconds: '00',
    });
    // console.log(acceptPrompt, '@@@')
    if (challenge?.challenge_status === 'SELECTED' && !acceptPrompt) {
      const originDeadline = challengeState?.repos?.deadline;
      const current = moment(new Date());
      const deadline = moment(current + moment(challenge?.time_left));
      const diff = deadline.diff(current, 'days') + 1;
      let pType;
      if (diff === 1 || originDeadline === 1) {
        pType = ACCEPTED_CHALLENGE_ONE_DAY_TO_GO
      } else {
        pType = ACCEPTED_CHALLENGE_PROMPT
      }
      // EventEmitter.dispatch('show_prompt', {
      //   showPrompt: 'block',
      //   challenge: challenge,
      //   promptType: pType
      // })
    }
  }, []);

  const uploadingGuidMessage = (
    <div className="uploading-guide-message-wrapper">
      <div className="text">
        If you have trouble uploading, please send it to us
        (contact@taletree.app).
      </div>
    </div>
  );

  const backToList = () => {
    if (from === 'feed') {
      history.goBack();
    }
    if (from === 'myroom') {
      history.replace({
        pathname: `${MY_ROOM_ROUTE}`,
        state: { tab: 'challenge' },
      });
    } else
      history.replace({
        pathname: `${NEXT_CHALLENGE_ROUTE}`,
        state: { filter, tag },
      });
  };

  const isSpecialCamp = (specialCampId, dependentSpecialCampId) => {
    if (specialCampId === dependentSpecialCampId) {
      return true
    } else return false
  }

  const handleAccept = (e) => {
    if (guardian) {
      localStorage.setItem('kids_login_location', window.location.href)
      setShowModal(true);
      return
    }
    if (dependent && !guardian) {
      if (!dependent.profile.is_activated) {
        setShowGetVerifiedModal(true)
      } else {
        setAcceptPrompt(true);
        const isAccept = challengeStatus !== ChallengeStatus['SELECTED'];
        if (isAccept) {
          setPromptType(NEW_CHALLENGE_PROMPT)
          challengeAccept(isAccept)
          EventEmitter.dispatch('accept_challenge', {})
          // EventEmitter.dispatch('show_prompt', {
          //   showPrompt: 'block',
          //   challenge: challenge,
          //   promptType: ACCEPT_CHALLENGE_PROMPT
          // })
          // setShowPrompt('block')
        }
        else setShowDisjoinConfirm(true);
      }
      // else {
      //   if (challenge.special_camp?.is_root && !dependent.subscriptions && !isSpecialCamp(challenge.special_camp?.id, dependent.special_camp.special_camp_id)) {
      //     setShowUpgradeModal(true)
      //   } else if (challenge.special_camp.id && !challenge.special_camp?.is_root && !isSpecialCamp(challenge.special_camp?.id, dependent.special_camp.special_camp_id)) {
      //     setShowUpgradeModal(true)
      //   } else {
      //     const isAccept = challengeStatus !== ChallengeStatus['SELECTED'];
      //     if (isAccept) {
      //       challengeAccept(isAccept)
      //       EventEmitter.dispatch('accept_challenge', {})
      //     }
      //     else setShowDisjoinConfirm(true);
      //   }
      // }
    }
    else {
      if (challenge.created_by?.user_type === "partner" || challenge.created_by?.user_type === "camp master") {
        let partner_signup = {
          id: challenge?.created_by?.id,
          picture_url: challenge?.created_by?.picture_url,
          is_verified: challenge?.treehouse_user?.is_verified,
          type_of_organisation: challenge?.treehouse_user?.type_of_organisation,
          user_type: challenge?.created_by?.user_type
        }
        localStorage.setItem('partner', JSON.stringify(partner_signup));
      }
      localStorage.setItem('kids_login_location', window.location.href)
      setShowModal(true)
    }
  };

  const challengeAccept = (isAccept) => {
    fetchAPI(nextChallengeViewModel.challengeAccept, cid, isAccept)
      .then((res) => {
        setAcceptResponse(res);
        // if kid unaccept a challenge
        (!isAccept || goToMyRoomCount <= 0) && changeChallengeState(res);
        // if kid accept a challenge
        if (goToMyRoomCount > 0 && isAccept) {
          setShowGoToMyroom(true);
          setGoToMyRoomCount(goToMyRoomCount - 1);
          localStorage.setItem('gotomyroom', goToMyRoomCount - 1);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err?.serverResponse?.result_code === 405008) {
          setShowTimeToUpgradePopup(true)
        }
        if (err.serverResponse.result_code === 405007) {
          setShowExceedMaxChallenge(true);
        }
      })
  };

  const changeChallengeState = (res) => {
    res = !res ? acceptResponse : res;
    const time =
      res.is_accept && challengeState.repos.deadline * 24 * 60 * 60 * 1000;
    const updated = {
      challenge_status: res.challenge_status,
      completed_dependent_count: res.completed_dependent_count,
      all_completed_dependents: res.all_completed_dependents,
      accepted_dependent_count: res.accepted_dependent_count,
      all_accepted_dependents: res.all_accepted_dependents,
      time_left: time,
    };
    setChallengeState({
      loading: false,
      repos: { ...challengeState.repos, ...updated },
    });
    setChallengeStatus(ChallengeStatus[res.challenge_status]);
    setAccepted(res.is_accept ? 'accepted' : '');
  };

  useEffect(() => {
    if (challengeState.repos) {
      const originDeadline = challengeState.repos.deadline;
      const current = moment(new Date());
      const deadline = moment(current + moment(leftTime));
      const diff = deadline.diff(current, 'days') + 1;
      setTextOfLeftDays(
        `${diff > originDeadline ? originDeadline : diff} ${diff === 1 || originDeadline === 1 ? ' day' : ' days'
        } to finish!`
      );
    }
  }, [leftTime]);

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    return (
      <span>
        {days}:{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
      </span>
    );
  };
  const handleComplete = ({ days, hours, minutes, seconds }) => {
    // console.log(Date.now());
    // console.log(leftTime);
    // console.log(`${days}:${hours}:${minutes}:${seconds}`);
  };

  const setTreehouseForAdd = (data) => {
    if (!dependent) {
      if (challenge.created_by?.user_type === "partner" || challenge.created_by?.user_type === "camp master") {
        let partner_signup = {
          id: challenge?.created_by?.id,
          picture_url: challenge?.created_by?.picture_url,
          is_verified: challenge?.treehouse_user?.is_verified,
          type_of_organisation: challenge?.treehouse_user?.type_of_organisation,
          user_type: challenge?.created_by?.user_type
        }
        localStorage.setItem('partner', JSON.stringify(partner_signup));
      }
      setShowModal(true)
    } else {
      setLoading(true)
      if (subscribedTreehouses.indexOf(data.id) != -1) {
        setSubscribedTreehouse(subscribedTreehouses.filter(item => item != data.id));
        fetchAPI(treehouseViewModel.unSubscribeTreehouse, data.id)
          .then((res) => {
            setLoading(false)
          })
          .catch((err) => { }).finally(() => {
            EventEmitter.dispatch('subscribe_treehouse', data)
          });
      }
      else {
        setSubscribedTreehouse([...subscribedTreehouses, data.id]);
        fetchAPI(treehouseViewModel.subscribeTreehouse, data.id)
          .then((res) => {
            setLoading(false)
          })
          .catch((err) => { }).finally(() => {
            EventEmitter.dispatch('subscribe_treehouse', data)
          });
      }
    }
  }

  const handleTreehouseClick = () => {
    if (challenge?.created_by?.user_type === "partner" || challenge?.created_by?.user_type === "camp master") {
      let id = challenge?.treehouse_user?.slug ? challenge?.treehouse_user?.slug : challenge?.treehouse_user?.id
      history.push({
        pathname: `${challenge?.treehouse_user?.type_of_organisation ? TREEHOUSE_ROUTE : EXPERT_ROUTE}/${id}`,
        state: {
          type: challenge?.treehouse_user?.slug ? 'slug' : 'id'
        }
      })
    } else if (challenge?.created_by?.user_type === "school_teacher") {
      history.push(`${CAPTAIN_ROUTE}/${challenge?.group?.id}`)
    } else if (challenge?.created_by?.user_type === "school") {
      history.push(`${CAPTAIN_ROUTE}/${dependent?.profile?.group?.id}`)
    }
  }

  const getSpecialCampProp = (challenge) => {
    if (challenge?.special_camp) {
      return challenge?.special_camp
    } else {
      if (challenge?.is_event) {
        let special_camp = {
          start_date: challenge?.start_date_time,
          time_zone: challenge?.timezone
        }
        return special_camp
      }
    }
  }

  return (
    <div>
      <div className="challenge-list-container challenge_img_top">
        <Container fluid="md" className="single-challenge">
          {challenge && (
            <>
              {partner || school ? (
                <div className="next-challenge-header-wrapper single"></div>
              ) : challenge?.is_event === true ? (
                <div className="next-challenge-header-wrapper single">
                  {/* <div className={`accept-wrapper ${accepted}`}>
                      <RoundButton
                        className={`accept-button ${accepted}`}
                        type="button"
                        label={
                          new Date(challenge.start_date_time) < Date.now() ?
                          <span>
                            <span className="change-string">Event Completed</span>
                          </span>
                          :
                          <span>
                            <FaCheck />{' '}
                            <span className="change-string">Join Event</span>
                          </span>
                        }
                      // onClick={handleAccept}
                      />
                    </div> */}
                </div>
              ) : (
                <div className="next-challenge-header-wrapper single">
                  <div className={`accept-wrapper ${accepted}`}>
                    {challenge?.created_by?.user_type === 'school' ||
                    challenge?.created_by?.user_type === 'school_teacher'||
                    !challenge?.special_camp?.id ||
                    !challenge?.is_event ? (
                      <RoundButton
                        className={`accept-button ${accepted}`}
                        type="button"
                        label={
                          <span>
                            {/* <FaCheck />{' '} */}
                            <span className="change-string">
                              Work on this challenge?
                            </span>
                          </span>
                        }
                        onClick={handleAccept}
                      />
                    ) : new Date(challenge.end_date_time) < Date.now() &&
                      accepted !== 'accepted' ? (
                      <RoundButton
                        className={`accept-button remove-pointer ${accepted}`}
                        type="button"
                        label={
                          <span>
                            <span className="change-string">
                              Challenge Ended
                            </span>
                          </span>
                        }
                      />
                    ) : (
                      <RoundButton
                        className={`accept-button ${accepted}`}
                        type="button"
                        label={
                          <span>
                            {/* <FaCheck />{' '} */}
                            <span className="change-string">
                              Work on this challenge?
                            </span>
                          </span>
                        }
                        onClick={handleAccept}
                      />
                    )}
                  </div>
                  <div className={`submit-wrapper ${accepted}`}>
                    <RoundButton
                      className={`creation-button ${accepted} gred-btn`}
                      type="button"
                      label={
                        <span>
                          Submit{' '}
                          <span className="button-arrow">
                            <TiArrowRightThick />
                          </span>
                        </span>
                      }
                      onClick={handleShowUpload}
                    />
                  </div>
                </div>
              )}
              <div className="challenge-countdown-wrapper">
                <div className={`countdown-wrapper ${challengeStatus}`}>
                  <span className="days-left">{textOfLeftDays}</span>
                  <div className="label-wrapper">
                    <span className="days-label label">Days</span>
                    <span className="hours-label label">Hours</span>
                    <span className="minutes-label label">Minutes</span>
                    <span className="seconds-label label">Seconds</span>
                  </div>
                  <div className="countdown">
                    <Countdown
                      date={Date.now() + leftTime}
                      renderer={countdownRenderer}
                      overtime={true}
                      onComplete={handleComplete}
                    />
                  </div>
                </div>
              </div>
              <div className="justify-content-md-center challenge-detail">
                <ChallengeCard
                  challenge={challengeState.repos}
                  type="challenge-detail"
                  noClick={true}
                  handleClick={() => {}}
                  isChallengePage={true}
                />
              </div>
              {school ? (
                ''
              ) : (
                <div className="postedby-single-chalenge-out-div">
                  <div className="postedby-single-chalenge-inner">
                    <div className="postedby-single-challenge-details">
                      <div
                        className="postedby-single-challenge-details-inner"
                        onClick={() => handleTreehouseClick()}
                      >
                        <div className="postedby-profile-img add-pointer">
                          {challenge?.treehouse_user?.picture ? (
                            <Image src={challenge?.treehouse_user?.picture} />
                          ) : challenge?.created_by?.user_type === 'school' ? (
                            <Image src={challenge?.created_by?.picture_url} />
                          ) : challenge?.created_by?.is_superuser === true ? (
                            <Image src={taletreeLogo} />
                          ) : challenge?.created_by?.user_type ===
                            'camp master' ? (
                            ''
                          ) : (
                            <Image src={defaultProfilePic} />
                          )}
                        </div>
                        <div className="postedby-name single-page-name">
                          <h4 onClick={() => handleTreehouseClick()}>
                            {challenge?.treehouse_user?.name
                              ? challenge?.treehouse_user?.name
                              : challenge?.created_by?.is_superuser === true
                              ? 'TaleTree'
                              : ''}
                            {challenge?.treehouse_user?.is_verified ? (
                              !challenge?.treehouse_user
                                ?.type_of_organisation &&
                              challenge?.treehouse_user?.user_type ===
                                'camp master' ? (
                                <span className="check-patch">
                                  <Image
                                    className="green-tick"
                                    src={verfiedIcon}
                                  />
                                </span>
                              ) : challenge?.treehouse_user
                                  ?.type_of_organisation === 'non profit' ? (
                                <span className="check-patch">
                                  <Image
                                    className="green-tick"
                                    src={silverTick}
                                  />
                                </span>
                              ) : challenge?.treehouse_user
                                  ?.type_of_organisation === 'profit' ? (
                                <span className="check-patch">
                                  <Image
                                    className="green-tick"
                                    src={goldTick}
                                  />
                                </span>
                              ) : (
                                challenge?.created_by?.user_type ===
                                  'school' && (
                                  <span className="check-patch">
                                    <Image
                                      className="green-tick"
                                      src={greenTick}
                                    />
                                  </span>
                                )
                              )
                            ) : challenge?.created_by?.is_superuser === true ? (
                              <span className="check-patch">
                                <BsFillPatchCheckFill />
                              </span>
                            ) : challenge?.created_by?.user_type ===
                                'school_teacher' ||
                              challenge?.created_by?.user_type === 'school' ? (
                              <span className="check-patch">
                                <Image className="green-tick" src={greenTick} />
                              </span>
                            ) : (
                              ''
                            )}
                          </h4>
                          <p className="add-pointer">
                            {challenge?.treehouse_user?.description
                              ? challenge?.treehouse_user?.description
                              : challenge?.created_by?.is_superuser === true
                              ? 'TaleTree magic right at your fingertips! ✨'
                              : ''}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {challenge.created_by?.user_type !== 'school_teacher' &&
                  challenge.created_by?.user_type !== 'school' ? (
                    <div className="postedby-single-challenge-subscribed-div">
                      <p className="expert-box">
                        <span>
                          <img
                            className="expert-img"
                            src={
                              challenge?.created_by?.picture_url
                                ? challenge?.created_by?.picture_url
                                : challenge?.treehouse_user?.picture
                            }
                          />
                        </span>
                        Meet the expert:{' '}
                        <span className="expert-name">
                          {challenge?.created_by?.is_superuser === true
                            ? 'Taletree'
                            : challenge?.created_by?.first_name +
                              ' ' +
                              challenge?.created_by?.last_name}
                        </span>
                        {challenge.special_camp?.id || challenge?.is_event ? (
                          <span className="expert-start-time">
                            {' '}
                            <SpecialCamp
                              specialCampProp={getSpecialCampProp(challenge)}
                            />
                          </span>
                        ) : (
                          ''
                        )}
                      </p>
                      {!partner &&
                        !challenge?.treehouse_user?.id &&
                        !challenge?.created_by?.is_superuser &&
                        !challenge?.created_by?.user_type === 'school' && (
                          <div>
                            <button
                              className="btn-subscribed"
                              onClick={() =>
                                setTreehouseForAdd(challenge.created_by)
                              }
                            >
                              {showSelected(challenge?.created_by?.id) ? (
                                <>
                                  <span className="btn-check">
                                    <BsCheck />
                                  </span>{' '}
                                  Subscribed
                                </>
                              ) : (
                                'Subscribe'
                              )}
                            </button>
                          </div>
                        )}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              )}
            </>
          )}
        </Container>
      </div>
      {challenge?.is_event && challenge?.is_event === true ? (
        ''
      ) : (
        <>
          <Container fluid="md" className="p-0">
            <section className="accepted-section">
              <div className="section-wrapper">
                <h5>{acceptedTitle}</h5>
                {acceptedCount > 8 ? (
                  <div
                    className="view-all"
                    onClick={handleToggleAcceptedDependents}
                  >
                    {toggleButton}
                  </div>
                ) : (
                  ''
                )}
              </div>
              {!challengeState.loading && (
                <AcceptedDependents
                  challenge={challengeState}
                  toggleAccepted={toggleAccepted}
                />
              )}
            </section>
            <section className="completed-section">
              <div className="section-wrapper">
                <h5>{completedTitle}</h5>
                <div className="toggle-view-mode">
                  <div
                    className={`toggle-view ${
                      toggleCompletedView ? 'selected' : ''
                    }`}
                    onClick={handleToggleView}
                  >
                    <FaThLarge />
                  </div>
                  <div
                    className={`toggle-view ${
                      !toggleCompletedView ? 'selected' : ''
                    }`}
                    onClick={handleToggleView}
                  >
                    <FaBars />
                  </div>
                </div>
              </div>
            </section>
            {!hasSubmission ? noSubmissionView() : completedView}
          </Container>
        </>
      )}
      <CreationUpload
        from="challenge"
        showUpload={showUpload}
        challengeId={cid}
        handleClose={handleCloseUpload}
        handleOnUploadComplete={onUploadComplete}
        setShowTimeToUpgradePopup={setShowTimeToUpgradePopup}
      />

      {/* Upload guide information modal */}
      <ChallengeModal
        handleClose={handleCloseUploadingGuide}
        show={showUploadingGuide}
        type="infos"
        level="infos"
        button1Label="Close"
      >
        {uploadingGuidMessage}
      </ChallengeModal>
      {/* When kid unaccept a challenge show warning message */}
      <ChallengeModal
        handleClose={() => setShowDisjoinConfirm(false)}
        handleAction={() => {
          challengeAccept(false);
          setShowDisjoinConfirm(false);
          EventEmitter.dispatch('accept_challenge', {});
        }}
        show={showDisjoinConfirm}
        type="confirm"
        level="warning"
        button1Label="Yes"
        button2Label="No"
      >
        Finishing your challenge is an achievement. Are you sure you want to
        quit this challenge for now?
      </ChallengeModal>
      {/* If kid accepted maximum challenges */}
      <ChallengeModal
        handleClose={() => setShowExceedMaxChallenge(false)}
        show={showExceedMaxChallenge}
        type="warning"
        level="warning"
        button1Label="Got it"
      >
        Oops! You can only choose up to three Challenges at a time. Please
        finish your Challenge before choosing a new one.
      </ChallengeModal>
      {/* When kid click the accept button */}
      <ChallengeModal
        handleClose={() => {
          setShowGoToMyroom(false);
          changeChallengeState();
        }}
        handleAction={() =>
          history.push({
            pathname: MY_ROOM_ROUTE,
            state: { tab: 'challenge' },
          })
        }
        show={showGoToMyroom}
        type="confirm"
        level="infos"
        button1Label="Go to My room"
        button2Label="Close"
      >
        Wonderful! You’ve decided to work on this challenge. Now you can see
        this Challenge in My Room.
      </ChallengeModal>

      <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
      {/* <CompanionPrompt
        type={promptType}
        challenge={challenge}
      // showPrompt={showPrompt}
      // setShowPrompt={setShowPrompt}
      /> */}
      {showGetVerifiedModal ? (
        <GetVerifiedNowModal
          show={showGetVerifiedModal}
          setShow={setShowGetVerifiedModal}
        />
      ) : (
        ''
      )}
      {showUpgradeModal ? (
        <UpgradeModal show={showUpgradeModal} setShow={setShowUpgradeModal} />
      ) : (
        ''
      )}
    </div>
  );
}

export default SingleChallengeDetails;
